import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const AccordionWrapper = styled.div`
    &&& .accordion {
        border: none;
        margin-top: 0.5rem;
        margin-bottom: 1rem;
        
        .accordion-header {
            border: none;
            color: #1175B5;
            justify-content: left;
            padding: 0 1.5rem 1.5rem 0;
            font-weight: normal;
        }
        
        .accordion-content {
            padding: 0;
        }
        
        ul li {
            list-style: disc;
            margin-left: 1rem;
        }
    }    
`;
